// Central registry of data-testid values used across the app.
export const HOME = {
  emergentLink: "home-emergent-link",
};

export const AUTH = {
  loginPageRoot: "login-page",
  googleLoginBtn: "google-login-btn",
  logoutBtn: "logout-btn",
};

export const NAV = {
  sidebar: "sidebar-nav",
  dashboardLink: "nav-dashboard-link",
  keywordsLink: "nav-keywords-link",
  auditLink: "nav-audit-link",
  competitorsLink: "nav-competitors-link",
  croLink: "nav-cro-link",
  reportsLink: "nav-reports-link",
  settingsLink: "nav-settings-link",
  shopSelector: "shop-selector",
  languageSwitcher: "language-switcher",
  themeToggle: "theme-toggle",
};

export const DASH = {
  overviewRoot: "dashboard-overview",
  kpiKeywords: "kpi-keywords",
  kpiAvgPosition: "kpi-avg-position",
  kpiVisibility: "kpi-visibility",
  kpiTraffic: "kpi-traffic",
  kpiRevenue: "kpi-revenue",
  visibilityChart: "visibility-chart",
  positionDistribution: "position-distribution",
};

export const KW = {
  root: "keywords-page",
  table: "keywords-table",
  row: (id) => `keyword-row-${id}`,
  searchInput: "keywords-search-input",
  refreshBtn: "keywords-refresh-btn",
};

export const AUDIT = {
  root: "audit-page",
  healthScore: "audit-health-score",
  cwvCard: "audit-cwv-card",
  issuesList: "audit-issues-list",
  issueRow: (i) => `audit-issue-${i}`,
};

export const COMP = {
  root: "competitors-page",
  chart: "competitors-chart",
  table: "competitors-table",
  addInput: "competitor-add-input",
  addBtn: "competitor-add-btn",
  deleteBtn: (id) => `competitor-delete-${id}`,
};

export const CRO = {
  root: "cro-page",
  funnel: "cro-funnel",
  step: (id) => `cro-step-${id}`,
  generateBtn: "cro-generate-btn",
  recommendationsList: "cro-recommendations",
  rec: (i) => `cro-rec-${i}`,
  progress: "cro-progress",
};

export const REP = {
  root: "reports-page",
  digestCard: "reports-digest-card",
  downloadPdfBtn: "reports-download-pdf",
  emailInput: "reports-email-input",
  sendEmailBtn: "reports-send-email-btn",
  subscriptionCard: "reports-subscription-card",
  subEmailInput: "reports-sub-email",
  subWeekdaySelect: "reports-sub-weekday",
  subHourSelect: "reports-sub-hour",
  subEnabledToggle: "reports-sub-enabled",
  subSaveBtn: "reports-sub-save",
  subRunNowBtn: "reports-sub-run-now",
};

export const INTEG = {
  googleConnectBtn: (shopId) => `google-connect-${shopId}`,
  googleDisconnectBtn: (shopId) => `google-disconnect-${shopId}`,
  googleStatusBadge: (shopId) => `google-status-${shopId}`,
};
